module.exports = __webpack_public_path__ + "static/img/bg.fafa06f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/five/bg.png
// module id = ilL6
// module chunks = 1